import {isNil} from 'ramda';

import {PriceBox, type PriceBoxProps} from '@dms/teas';

import {Nullish} from 'shared/web';

import {PriceNotAvailable} from '../../../PriceNotAvailable/PriceNotAvailable';

interface AlternativePriceBoxProps {
  title?: string;
  price: {withVat: PriceBoxProps['price']; withoutVat: PriceBoxProps['priceSub']} | Nullish;
  align: 'left' | 'right';
  size?: PriceBoxProps['size'];
}

/**
 * A price of a non-applied alternative. Those keep their negotiated prices, so a missing one was
 * withheld for a missing permission: it reads as not available, never as an empty price.
 */
export function AlternativePriceBox(props: AlternativePriceBoxProps) {
  if (isNil(props.price)) {
    return <PriceNotAvailable title={props.title} align={props.align} />;
  }

  return (
    <PriceBox
      title={props.title}
      align={props.align}
      size={props.size}
      price={props.price.withVat}
      priceSub={props.price.withoutVat}
    />
  );
}
